module.exports = __webpack_public_path__ + "media/proksee-viewer/images/icon-expand-ffde1a77f945bf4d0781c29cc304532b.png";